import { extendTheme } from '@chakra-ui/react';

const sharedColors = {
  accent: {
    teal: '#2dd4bf',
    tealDark: '#14b8a6',
    amber: '#f59e0b',
    amberDark: '#d97706',
    red: '#ef4444',
    redDark: '#dc2626',
    green: '#22c55e',
  },
};

export const dayTheme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  colors: {
    micu: {
      bg: '#ffffff',
      bgSecondary: '#f7f8fa',
      bgTertiary: '#edf0f4',
      text: '#1a202c',
      textSecondary: '#4a5568',
      textMuted: '#a0aec0',
      border: '#e2e8f0',
      borderStrong: '#cbd5e0',
      card: '#ffffff',
      cardHover: '#f7fafc',
      header: '#f7f8fa',
      ...sharedColors.accent,
    },
  },
  fonts: {
    heading: 'Inter, -apple-system, sans-serif',
    body: 'Inter, -apple-system, sans-serif',
    mono: '"SF Mono", "Fira Code", monospace',
  },
  styles: {
    global: {
      'html, body': {
        bg: 'micu.bg',
        color: 'micu.text',
        minHeight: '100vh',
        WebkitFontSmoothing: 'antialiased',
      },
      '#root': {
        minHeight: '100vh',
      },
    },
  },
  components: {
    Button: {
      variants: {
        micuPrimary: {
          bg: 'micu.teal',
          color: 'white',
          fontWeight: '600',
          _hover: { bg: 'micu.tealDark' },
          _active: { bg: 'micu.tealDark' },
        },
        micuGhost: {
          bg: 'transparent',
          color: 'micu.text',
          _hover: { bg: 'micu.bgSecondary' },
        },
        micuDanger: {
          bg: 'micu.red',
          color: 'white',
          _hover: { bg: 'micu.redDark' },
        },
      },
    },
    Card: {
      baseStyle: {
        container: {
          bg: 'micu.card',
          border: '1px solid',
          borderColor: 'micu.border',
          borderRadius: 'lg',
          color: 'micu.text',
        },
      },
    },
    Input: {
      variants: {
        micu: {
          field: {
            bg: 'micu.bg',
            border: '1px solid',
            borderColor: 'micu.border',
            color: 'micu.text',
            _placeholder: { color: 'micu.textMuted' },
            _focus: { borderColor: 'micu.teal', boxShadow: '0 0 0 1px #2dd4bf' },
          },
        },
      },
    },
    Select: {
      variants: {
        micu: {
          field: {
            bg: 'micu.bg',
            border: '1px solid',
            borderColor: 'micu.border',
            color: 'micu.text',
            _focus: { borderColor: 'micu.teal', boxShadow: '0 0 0 1px #2dd4bf' },
          },
        },
      },
    },
    Modal: {
      baseStyle: {
        dialog: {
          bg: 'micu.bg',
          color: 'micu.text',
        },
      },
    },
  },
});

export const nightTheme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  colors: {
    micu: {
      bg: '#0d0f1a',
      bgSecondary: '#141829',
      bgTertiary: '#1a1f36',
      text: '#c4cfde',
      textSecondary: '#8b9bb4',
      textMuted: '#5a6a82',
      border: '#1e2640',
      borderStrong: '#2a3454',
      card: '#141829',
      cardHover: '#1a1f36',
      header: '#0d0f1a',
      ...sharedColors.accent,
    },
  },
  fonts: {
    heading: 'Inter, -apple-system, sans-serif',
    body: 'Inter, -apple-system, sans-serif',
    mono: '"SF Mono", "Fira Code", monospace',
  },
  styles: {
    global: {
      'html, body': {
        bg: 'micu.bg',
        color: 'micu.text',
        minHeight: '100vh',
        WebkitFontSmoothing: 'antialiased',
      },
      '#root': {
        minHeight: '100vh',
      },
    },
  },
  components: {
    Button: {
      variants: {
        micuPrimary: {
          bg: 'micu.tealDark',
          color: 'white',
          fontWeight: '600',
          _hover: { bg: 'micu.teal' },
          _active: { bg: 'micu.teal' },
        },
        micuGhost: {
          bg: 'transparent',
          color: 'micu.text',
          _hover: { bg: 'micu.bgTertiary' },
        },
        micuDanger: {
          bg: 'micu.redDark',
          color: 'white',
          _hover: { bg: 'micu.red' },
        },
      },
    },
    Card: {
      baseStyle: {
        container: {
          bg: 'micu.card',
          border: '1px solid',
          borderColor: 'micu.border',
          borderRadius: 'lg',
          color: 'micu.text',
        },
      },
    },
    Input: {
      variants: {
        micu: {
          field: {
            bg: 'micu.bgSecondary',
            border: '1px solid',
            borderColor: 'micu.border',
            color: 'micu.text',
            _placeholder: { color: 'micu.textMuted' },
            _focus: { borderColor: 'micu.teal', boxShadow: '0 0 0 1px #14b8a6' },
          },
        },
      },
    },
    Select: {
      variants: {
        micu: {
          field: {
            bg: 'micu.bgSecondary',
            border: '1px solid',
            borderColor: 'micu.border',
            color: 'micu.text',
            _focus: { borderColor: 'micu.teal', boxShadow: '0 0 0 1px #14b8a6' },
          },
        },
      },
    },
    Modal: {
      baseStyle: {
        dialog: {
          bg: 'micu.bgSecondary',
          color: 'micu.text',
        },
      },
    },
  },
});
